import React, { useEffect, useState, useMemo } from "react";

import moment from "moment";
import { NavLink, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const Header = () => {
  const nav = useNavigate();

  const [weatherData, setWeatherData] = useState("");
  const [currentDay, setCurrentDay] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const getWeatherData = async (latitude, longitude) => {
    try {
      const response = await fetch(
        `https://api.weatherapi.com/v1/current.json?q=${latitude},${longitude}&key=d91f9b463dfb40c8873110928231506`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      // console.log(response);

      if (response.ok) {
        const res = await response.json();
        // console.log(res);
        setWeatherData(res.current || "");
      } else {
        console.error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error during fetch:", error.message);
    }
  };

  useEffect(() => {
    const today = new Date();

    const dayOptions = { weekday: "long" };
    const dayName = today.toLocaleDateString("en-US", dayOptions);

    const dateOptions = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = today.toLocaleDateString("en-US", dateOptions);

    setCurrentDay(dayName);
    setCurrentDate(formattedDate);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          getWeatherData(latitude, longitude);
          // console.log(weatherData.condition);
        },
        (error) => {
          console.error("Error getting geolocation:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by your browser");
    }
  }, []);

  return (
    <>
      <div className="content-header">
        <nav className="navbar navbar-expand navbar-white navbar-light">
          {/* LEFT SIDE */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <span
                className="text-left bg-info px-2 py-1"
                style={{
                  borderRadius: "4px",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                {currentDay} {currentDate}{" "}&nbsp;&nbsp;&nbsp;
                {weatherData && `${weatherData.temp_c} °C`}{" "}
                {weatherData?.condition?.text || " "}
                {weatherData?.condition?.icon && (
                  <img
                    src={weatherData.condition.icon}
                    alt="Weather"
                    height="30"
                    width="30"
                    style={{ marginLeft: "5px" }}
                  />
                )}
              </span>
            </li>
          </ul>

          {/* RIGHT SIDE */}
          <ul className="navbar-nav ml-auto">
            <li className="nav-item dropdown user-menu">
              <a
                href="#"
                className="nav-link dropdown-toggle"
                data-toggle="dropdown"
              >
                <img
                  src={`${process.env.REACT_APP_FILE_URL}${localStorage.getItem(
                    "userIcon"
                  )}`}
                  className="user-image img-circle elevation-2"
                  alt=""
                />
                <span className="d-none d-md-inline">
                  {localStorage.getItem("employeeName")}
                </span>
              </a>
              <ul className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <li className="user-header bg-primary">
                  <img
                    src={`${
                      process.env.REACT_APP_FILE_URL
                    }${localStorage.getItem("userIcon")}`}
                    className="img-circle elevation-2"
                    alt="User Image"
                  />
                  <p>
                    {localStorage.getItem("employeeName")}
                    <small>{localStorage.getItem("organizationName")}</small>
                  </p>
                </li>
                <li className="user-footer">
                  <NavLink
                    to="/userProfile"
                    className="btn btn-default btn-flat"
                  >
                    Profile
                  </NavLink>
                  <a
                    onClick={() => {
                      localStorage.clear();
                      Cookies.remove("token");
                      nav("/auth");
                    }}
                    className="btn btn-default btn-flat float-right"
                  >
                    Sign out
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <hr style={{ margin: "0", padding: "0" }} />
      </div>
    </>
  );
};

export default Header;
